import { PlayerContactActionsComponent } from '../shared/player-contact-actions/player-contact-actions.component';
import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CoreModule} from "../core/core.module";
import {FormsModule} from '@angular/forms';
import {PlayerDetailFormComponent} from './player-detail/player-detail.component';
import {PlayerService} from '../shared/services/player.service';
import {PlaySpaceService} from "../shared/services/playspace.service";
import {IpInfoLocationService} from "../shared/services/ipinfo.location.service";
//import {NgxLoadingModule} from 'ngx-loading';
import {GuestClaimComponent} from "./guest-claim/guest-claim.component";
import {PublicPlayerProfileComponent} from "./public-player-profile/public-player-profile.component";
import {PlayerMatchHistoryComponent} from "./player-match-history/player-match-history.component";
import {PlayerFootballerFriendsComponent} from "./player-footballer-friends/player-footballer-friends.component";
import {PlayerFootballReferencesComponent} from "./player-football-references/player-football-references.component";
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TypeaheadModule} from 'ngx-bootstrap/typeahead';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import { NgxSpinnerModule } from "ngx-spinner";
import { RatingModule } from 'ngx-bootstrap/rating';
import { TranslateModule } from '@ngx-translate/core';
import { StatsService } from '../shared/services/stats.service';
import { NogoshIconPipe } from '../shared/icons/nogosh-icon.pipe';
import { LoadingProgressComponent } from "../shared/loading-progress/loading-progress.component";
import { ScreenShellComponent } from "../shared/screen-shell/screen-shell.component";


@NgModule({
  imports: [PlayerContactActionsComponent,
    CommonModule, 
    FormsModule, 
    PopoverModule, 
    CoreModule, 
    TypeaheadModule, 
    BsDropdownModule, 
//    NgxLoadingModule.forRoot({}), 
    NgxSpinnerModule,
    RatingModule,
    TranslateModule,
    NogoshIconPipe,
    LoadingProgressComponent,
    ScreenShellComponent
  ],
  exports: [PlayerDetailFormComponent, GuestClaimComponent, PublicPlayerProfileComponent, PlayerMatchHistoryComponent, PlayerFootballerFriendsComponent, PlayerFootballReferencesComponent],
  declarations: [PlayerDetailFormComponent, GuestClaimComponent, PublicPlayerProfileComponent, PlayerMatchHistoryComponent, PlayerFootballerFriendsComponent, PlayerFootballReferencesComponent],
  providers: [PlayerService, PlaySpaceService, IpInfoLocationService, StatsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PlayerModule {
}
